import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

function handleClick(evt : JQuery.ClickEvent) {
	const $item = $(evt.currentTarget).closest('.scsh-has-subnav');
	// Deactivate other active items
	{
		// Other LIs on the same level
		$item.siblings('.active').removeClass('active');
	}

	$item.toggleClass('active');

	// This makes the MDD animate promptly and makes click tracking asynchronous.
	evt.preventDefault();

	const $a = $($item.find('a').get(0));
	const trackingLinkName = $a.data('tracking-link-name') || $a.text();
	scsHeader.siteCatalyst
		.trackClick(
			$a.get(0) as HTMLElement,
			evt,
			trackingLinkName,
			'l1-mdd',
		);
}

/**
 * Mega Drop Down support
 *
 * @author Nikola Tica
 * @class MDD
 * @extends Tc.Module
 */
export default class MDD extends Module {
	public on(callback : Hook) {
		// Close MDD on outsied click
		if(this.$ctx.data('attach-global-listeners')) {
			$(document).on('click', (e : JQuery.ClickEvent) => {
				if (!$(e.target).closest('.menu-items').length) {
					this.$ctx.find('.scsh-icon-menu > li.active, .menu-items > li.scsh-has-subnav.active')
					.not(':has(> .modFlyout)').find('> a, .lvl1-item a')
					.trigger('click');
				}
			});
		}

		this.initMDD();
		this.initMDDTracking();
		callback();
	}

	private initMDD() {
		const items = this.$ctx.find('.menu-items > .scsh-has-subnav');

		items.children('.lvl1-item').on('click', (evt : JQuery.ClickEvent) => {
			if (evt.originalEvent) {
				setTimeout(() => handleClick(evt));
			} else {
				handleClick(evt);
			}
		});
	}

	private initMDDTracking() {
		this.$ctx.find('.secondary-navigation .link .aTag').on('click', (evt : JQuery.ClickEvent) => {
			const $this = $(evt.currentTarget);
			const $mddLvl1Link = $this.closest('.scsh-has-subnav').find('h2 a');
			const mddLvl1 = $mddLvl1Link.data('tracking-link-name') ||
				$mddLvl1Link.text() ||
				'mddLvl1';
			const mddLvl2 = `${$.trim(mddLvl1)}_${($this.data('track-linkname') || $.trim($this.find('h4').text()))}`;

			scsHeader.siteCatalyst.trackClick(evt.currentTarget, evt, mddLvl2, 'l1-mdd');
		});
		this.$ctx.find('.secondary-navigation li a.linklist').on('click', (evt : JQuery.ClickEvent) => {
			const $this = $(evt.currentTarget);
			const $mddLvl1Link = $this.closest('.scsh-has-subnav').find('h2 a');
			const mddLvl1 = $mddLvl1Link.data('tracking-link-name') ||
				$mddLvl1Link.text() ||
				'mddLvl1';
			const mddLvl2 = $this.parents('.column').find('a').data('track-linkname') ||
				$this.parents('.column').find('h4:first, .modPromoBadge').text() ||
				'mddLvl2';
			const mddLvl3 = `${$.trim(mddLvl1)}_${$.trim(mddLvl2)}_${($this.data('tracking-link-name') || $this.text())}`;

			scsHeader.siteCatalyst.trackClick(evt.currentTarget, evt, mddLvl3, 'l1-mdd');
		});
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/header/Tc.Module.MDD.ts